/* eslint-disable no-undef */
/**
 * Common
 *
 * Scripts for all pages.
 *
 * @since 1.0.0
 */

import $ from 'jquery'; // eslint-disable-line import/no-unresolved
import cart from '../util/cart';
import checkoutAddons from '../util/checkoutAddons';

export default {
  init() {
    // JavaScript to be fired on all pages
    const btnCopy = document.getElementById('copy');
    const langButton = document.querySelector('.top-header__lang-button');
    const caret = document.querySelector('.top-header__lang-caret');
    const langMenu = document.querySelector(
      '.top-header__lang--mobile .lang__menu'
    );
    if (langButton && langMenu && caret) {
      langButton.addEventListener('click', () => {
        langMenu.classList.toggle('open');
        caret.classList.toggle('open');
      });
    }

    const addToCartButtons = $('.add_to_cart_button');
    if (addToCartButtons) {
      addToCartButtons.removeClass('ajax_add_to_cart');
    }

    if (btnCopy) {
      btnCopy.onclick = () => {
        const dummy = document.createElement('input');
        const text = window.location.href;
        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();

        document.execCommand('Copy');
        document.body.removeChild(dummy);
      };
    }

    // Load more text with click
    const btnText = document.querySelectorAll('.link');
    const dots = document.getElementById('dots');
    const moreText = document.getElementById('more');
    const catLink = document.querySelector('.category-content__link');

    if (btnText) {
      Array.from(btnText).forEach((btn) => {
        // eslint-disable-next-line
        btn.onclick = function (e) {
          e.preventDefault();

          if (dots.style.display === 'none') {
            catLink.style.display = 'flex';
            dots.style.display = 'inline';
            moreText.style.display = 'none';
          } else {
            catLink.style.display = 'none';
            dots.style.display = 'none';
            moreText.style.display = 'inline';
          }
        };
      });
    }

    // Shipping country JS
    const locationSelectButton = document.getElementById(
      'select-location-select'
    );
    const locationSelectModal = document.querySelector(
      '.location-select-modal'
    );
    const locationSelectCancel = document.getElementById(
      'select-location-cancel'
    );
    const topLinkLocationSelect = document.querySelector(
      '.top-header .location-select'
    );

    function getCookie(cname) {
      const name = `${cname}=`;
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }

    const cookiesSet =
      !!getCookie('language') &&
      !!getCookie('currency') &&
      !!getCookie('location');

    // Handle Modal Button click
    if (locationSelectButton) {
      locationSelectButton.addEventListener('click', () => {
        locationSelectModal.classList.toggle('hidden');
      });
    }
    // Handle Modal Button cancel
    if (locationSelectCancel) {
      locationSelectCancel.addEventListener('click', () => {
        locationSelectModal.classList.toggle('hidden');
      });
    }
    // Handle Top Header link click
    if (topLinkLocationSelect) {
      if (cookiesSet) {
        topLinkLocationSelect.classList.remove('hidden');
      }
      topLinkLocationSelect.addEventListener('click', () => {
        locationSelectModal.classList.toggle('hidden');
      });
    }
    // Modal
    if (locationSelectModal) {
      if (!cookiesSet) {
        locationSelectModal.classList.remove('hidden');
      }
    }

    // Cart specific JS
    cart();

    // Checkout specific JS
    checkoutAddons();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
